document.addEventListener("DOMContentLoaded", () => {
  
  const metalRadios = document.querySelectorAll('input[name="Metal"]');
  const metalColorDropdown = document.querySelector('#metal-color');

  
  function updateMetalColorVisibility() {
    let selectedMetal = '';
    metalRadios.forEach(radio => {
      if (radio.checked) {
        selectedMetal = radio.value;
      }
    });

    if (selectedMetal === 'Platinum') {
      metalColorDropdown.closest('.product-form__input').style.display = 'none';
      metalColorDropdown.removeAttribute('required'); 
      metalColorDropdown.value = ''; 
    } else {
      metalColorDropdown.closest('.product-form__input').style.display = 'block';
      metalColorDropdown.setAttribute('required', 'required'); 
      
      
      if (selectedMetal === 'Silver') {
        metalColorDropdown.value = 'White Gold'; 
      }
    }
  }

  
  metalRadios.forEach(radio => {
    radio.addEventListener('change', updateMetalColorVisibility);
  });

  
  updateMetalColorVisibility();
});
